import { MessagePathRecord, TopicRecord } from "@/shared/domain/topics";

// Workspace action types that can be published via PubSubBus
export type WorkspaceActionType =
  | "open_message_path"
  | "open_topic_search"
  | "seek_timer";

// Payload for opening a message path panel in the visualizer
export interface OpenMessagePathPayload {
  messagePath: MessagePathRecord;
  topic: TopicRecord;
  timestamp?: bigint;
}

// Payload for opening topic search in the visualizer
export interface OpenTopicSearchPayload {
  topic: TopicRecord;
  timestamp?: bigint;
}

// Payload for seeking the timer to a specific timestamp
export interface SeekTimerPayload {
  timestamp: bigint;
}

// Union type for all workspace action payloads
export type WorkspaceActionPayload =
  | { type: "open_message_path"; payload: OpenMessagePathPayload }
  | { type: "open_topic_search"; payload: OpenTopicSearchPayload }
  | { type: "seek_timer"; payload: SeekTimerPayload };

// PubSub topic names
export const WORKSPACE_ACTION_TOPIC = "workspace:action";
